var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useCallback, useEffect, useState } from 'react';
import { useMultiAutocomplete, MultiAutocompleteTokenControl, } from '@adsk/alloy-react-dropdown';
import { LocationNameDisplay } from '../../LocationNameDisplay';
import LocationsDropdownTreeMenu from './LocationsDropdownTreeMenu';
import { useUnspecifiedProps } from '../../helpers/unspecifiedHelper';
export var LocationsDropdownTreeMultiple = function (_a) {
    var selectedNodes = _a.selectedNodes, handleNodeSelectToggle = _a.handleNodeSelectToggle, isOpen = _a.isOpen, setIsOpen = _a.setIsOpen, selectLocationPlaceHolder = _a.selectLocationPlaceHolder, searchPlaceholder = _a.searchPlaceholder, _b = _a.searchTerm, searchTerm = _b === void 0 ? '' : _b, searchLocations = _a.searchLocations, getTreeNodeProps = _a.getTreeNodeProps, getTreeProps = _a.getTreeProps, useDropdownProps = _a.useDropdownProps, disabled = _a.disabled, container = _a.container, showIncludeUnspecified = _a.showIncludeUnspecified, includeUnspecified = _a.includeUnspecified, onUnspecifiedSelect = _a.onUnspecifiedSelect, menuProps = __rest(_a, ["selectedNodes", "handleNodeSelectToggle", "isOpen", "setIsOpen", "selectLocationPlaceHolder", "searchPlaceholder", "searchTerm", "searchLocations", "getTreeNodeProps", "getTreeProps", "useDropdownProps", "disabled", "container", "showIncludeUnspecified", "includeUnspecified", "onUnspecifiedSelect"]);
    // MultiAutocompleteTokenControl doesn't support custom placeholders yet,
    // keeping this code commented out so we can use it later once they do support it
    var _c = __read(useState(searchTerm), 2), inputValue = _c[0], setInputValue = _c[1];
    var _d = __read(useState(null), 2), unspecifiedItemIndex = _d[0], setUnspecifiedItemIndex = _d[1];
    var handleInputChange = useCallback(function (_a) {
        var newInputValue = _a.inputValue;
        setInputValue(newInputValue);
        isOpen && searchLocations(newInputValue);
    }, [setInputValue, isOpen, searchLocations]);
    useEffect(function () {
        setInputValue(searchTerm);
    }, [searchTerm]);
    var onIsOpenChange = useCallback(function (_a) {
        var isOpen = _a.isOpen;
        setIsOpen(isOpen);
    }, [setIsOpen]);
    var _e = useMultiAutocomplete(__assign(__assign({}, useDropdownProps), { 
        // overriding default filtering function to always return all items as we use onInputValueChange to filter items
        // @ts-ignore: getFilteredItems is accepted in useMultiAutocomplete but type definition does not include it (needs fixing in Alloy lib)
        getFilteredItems: useCallback(function (_a) {
            var allItems = _a.allItems;
            return allItems;
        }, []), onInputValueChange: handleInputChange, inputValue: inputValue, isOpen: isOpen, onIsOpenChange: onIsOpenChange, selectedItem: null, selectedItems: selectedNodes })), getInputProps = _e.getInputProps, getComboboxProps = _e.getComboboxProps, getSelectedItemProps = _e.getSelectedItemProps, getToggleButtonProps = _e.getToggleButtonProps, getLabelProps = _e.getLabelProps, getMenuProps = _e.getMenuProps, menuItems = _e.menuItems, _selectedItems = _e.selectedItems, targetProps = _e.targetProps, overlayProps = _e.overlayProps, openMenu = _e.openMenu;
    // TODO - pass placeholder values to MultiAutocompleteTokenControl once it supports it
    // const localeSearchPlaceholder =
    //   searchPlaceholder || T.translate('locationPicker.searchPlaceholder');
    // const localePlaceHolder =
    //   selectLocationPlaceHolder || T.translate('locationPicker.selectLocations');
    var _f = useUnspecifiedProps(), unspecifiedId = _f.unspecifiedId, menuItem = _f.menuItem, unspecifiedItem = _f.unspecifiedItem;
    var selectedItems = __spreadArray([], __read(_selectedItems), false);
    if (showIncludeUnspecified) {
        menuItems.push(menuItem);
        if (includeUnspecified) {
            if (!selectedItems.find(function (item) { return item.id === unspecifiedId; })) {
                var unspecifiedItemNewIndex = unspecifiedItemIndex !== null && unspecifiedItemIndex !== void 0 ? unspecifiedItemIndex : selectedItems.length;
                selectedItems = __spreadArray(__spreadArray(__spreadArray([], __read(selectedItems.slice(0, unspecifiedItemNewIndex)), false), [
                    unspecifiedItem
                ], false), __read(selectedItems.slice(unspecifiedItemNewIndex)), false);
                if (unspecifiedItemIndex === null) {
                    setUnspecifiedItemIndex(unspecifiedItemNewIndex);
                }
            }
        }
        else {
            selectedItems = selectedItems.filter(function (item) { return item.id !== unspecifiedId; });
            if (unspecifiedItemIndex !== null) {
                setUnspecifiedItemIndex(null);
            }
        }
    }
    return (React.createElement("div", null,
        React.createElement(MultiAutocompleteTokenControl, { isOpen: isOpen, isDisabled: disabled, selectedItems: selectedItems, getSelectedItemProps: getSelectedItemProps, getToggleButtonProps: getToggleButtonProps, getLabelProps: getLabelProps, targetProps: targetProps, removeSelectedItem: handleNodeSelectToggle, getComboboxProps: getComboboxProps, openMenu: openMenu, getInputProps: getInputProps, 
            // @ts-ignore: itemToString expects a string but we return a ReactNode type
            itemToString: function (node) { return (React.createElement(LocationNameDisplay, { locationNodeId: node.id })); } }),
        React.createElement(LocationsDropdownTreeMenu, __assign({ overlayProps: overlayProps, getMenuProps: getMenuProps, getTreeProps: getTreeProps, getTreeNodeProps: getTreeNodeProps, targetProps: targetProps, menuItems: menuItems, selectedNodes: selectedNodes, isOpen: isOpen, multiple: true, container: container, showIncludeUnspecified: showIncludeUnspecified, includeUnspecified: includeUnspecified, onUnspecifiedSelect: onUnspecifiedSelect }, menuProps))));
};
